/** Marks the `…` panel: the authored content div inside the collapsing breadcrumb's popover. */
export const BREADCRUMB_ELLIPSIS_PANEL_ATTR = 'data-breadcrumb-ellipsis-panel';

/**
 * A folded switcher's popover opens from inside the `…` panel, so panel interactions reach it as
 * outside-dismissal; guarding them keeps it open while genuine outside clicks still dismiss.
 */
export function isInsideBreadcrumbEllipsisPanel(target: EventTarget | null): boolean {
	if (!(target instanceof Element)) return false;
	return target.closest(`[${BREADCRUMB_ELLIPSIS_PANEL_ATTR}]`) !== null;
}
